<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Vue Notification UI"/>
    <div class="notification-form">
      <div class="form-group">
        <label class="font-weight-bold">Notification Title</label>
        <input type="text" placeholder="Enter the notification's title" v-model="notification.title" class="form-control"/>
      </div>
      <div class="form-group">
        <label class="font-weight-bold">Notification Body</label>
        <textarea rows="3" placeholder="Enter the notification's body" v-model="notification.body" class="form-control"></textarea>
      </div>
      <div class="form-group">
        <label class="font-weight-bold">Notification Type</label>
        <select class="form-control" v-model="notification.icon">
          <optgroup label="normal">
            <option value="default">default</option>
            <option value="success">success</option>
            <option value="info">info</option>
            <option value="warning">warning</option>
            <option value="danger">danger</option>
          </optgroup>
          <optgroup label="icon">
            <option value="https://uifaces.co/our-content/donated/bUkmHPKs.jpg">Male Avatar</option>
            <option value="https://i.imgur.com/ztMTpBt.jpg">Female Avatar</option>
            <option value="https://www.flaticon.com/svg/static/icons/svg/758/758797.svg">Icon Image</option>
          </optgroup>
        </select>
      </div>
      <div class="form-group">
        <button @click="showMessage" class="btn btn-primary">Notify a Message</button>
      </div>
    </div>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  },
  data () {
    return {
      notification: {
        title: 'ការជូនដំណឹងថ្មីៗ',
        body: 'សូមបងប្អួនទាំងអស់គ្នាមេត្តាប្រុងប្រយ័ត្ននៃរលកលើកទី២នៃជម្ញឺកូវីដ១៩',
        icon: 'default',
        dateTime: '3 hours ago'
      }
    }
  },
  methods: {
    showMessage () {
      this.$notification(this.notification.title, this.notification.body, this.notification.icon, async () => {
        console.log('Clicked Notification!')
      }, this.dateTime)
    }
  }
}
</script>

<style>
@import "https://cdn.jsdelivr.net/npm/bootstrap@4.5.3/dist/css/bootstrap.min.css";
@import 'https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap';
@import 'https://fonts.googleapis.com/css2?family=Battambang:wght@400;700&family=Dangrek&family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap';
#app {
  font-family: "Raleway", "Dangrek", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 120px;
}
.notification-form {
  width: 450px;
  margin: 0 auto;
  text-align: left;
}
</style>
